import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";

import Button from "@material-ui/core/Button";
import { asyncAssignMyContentFromContentList } from "../../actions/contentActions";

export const MarkAsToWatch = ({ contentId }) => {
  const dispatch = useDispatch();
  const handleActionClick = () => {
    dispatch(asyncAssignMyContentFromContentList(contentId));
  };
  const { request } = useSelector((state) => ({
    request: state.request.request,
  }));
  return (
    <Button
      variant="contained"
      color="primary"
      disabled={request.isFetching}
      onClick={() => handleActionClick()}
      data-testid="content-watched"
    >
      Mark as To Watch
    </Button>
  );
};

MarkAsToWatch.propTypes = {
  contentId: PropTypes.number,
};

MarkAsToWatch.defaultProps = {
  contentId: 0,
};
